var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gantt-elastic',{attrs:{"tasks":_vm.tasks,"options":_vm.options}},[_c('gantt-elastic-header',{attrs:{"slot":"header"},slot:"header"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }